
import React from 'react';

export const ComparisonSection: React.FC = () => {
  const comparisons = [
    {
      aspect: 'Closing Timeline',
      traditional: 'Average 90-120 days',
      cashSale: 'As fast as 14 days'
    },
    {
      aspect: 'Commissions & Fees',
      traditional: 'Up to 8% in total costs',
      cashSale: 'Zero fees or commissions'
    },
    {
      aspect: 'Property Repairs',
      traditional: 'Must fix all issues',
      cashSale: 'Sell as-is condition'
    },
    {
      aspect: 'Financing Risk',
      traditional: 'Buyer financing can fail',
      cashSale: 'Guaranteed cash purchase'
    },
    {
      aspect: 'Inspections',
      traditional: 'Multiple inspections required',
      cashSale: 'Minimal inspection process'
    },
    {
      aspect: 'Showings',
      traditional: 'Constant property showings',
      cashSale: 'One simple walkthrough'
    },
    {
      aspect: 'Market Dependence',
      traditional: 'Subject to market conditions',
      cashSale: 'Not affected by market swings'
    },
    {
      aspect: 'Paperwork',
      traditional: 'Extensive documentation',
      cashSale: 'We handle all paperwork'
    }
  ];

  return (
    <section id="why-us" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Why Sell to Cash Buyers?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Compare the traditional selling process with our streamlined cash purchase approach
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="grid md:grid-cols-3 bg-gray-50 py-6 px-8 font-semibold text-lg">
            <div className="text-gray-800">Selling Aspect</div>
            <div className="text-red-600 text-center">Traditional Sale</div>
            <div className="text-green-600 text-center">Cash Sale with Us</div>
          </div>

          {comparisons.map((item, index) => (
            <div 
              key={index} 
              className={`grid md:grid-cols-3 py-6 px-8 border-b border-gray-100 ${
                index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'
              }`}
            >
              <div className="font-medium text-gray-900 mb-2 md:mb-0">
                {item.aspect}
              </div>
              
              <div className="text-center mb-2 md:mb-0">
                <div className="flex items-center justify-center text-red-600">
                  <i className="ri-close-circle-fill mr-2 text-xl"></i>
                  <span>{item.traditional}</span>
                </div>
              </div>
              
              <div className="text-center">
                <div className="flex items-center justify-center text-green-600">
                  <i className="ri-checkbox-circle-fill mr-2 text-xl"></i>
                  <span className="font-medium">{item.cashSale}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="inline-block bg-green-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Ready to Experience the Difference?
            </h3>
            <p className="text-gray-600 mb-6">
              Get your no-obligation cash offer and see why property owners choose us
            </p>
            <a 
              href="#get-offer" 
              className="inline-flex items-center bg-orange-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get My Cash Offer
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
